import React, { useEffect, useRef, useState, useLayoutEffect } from "react";
import Select, { StylesConfig } from 'react-select';
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { getAccountExpenseTypeByAccountTaxZoneIdAsync, getAccountExpenseTypesAsync, resetSelectedRecordObjectInState ,deleteAllSelectedRecordExpenseTypeAsync,updatePagination} from "./expensetypeSlice";
import ExpenseTypeItem from "./ExpenseTypeItem";
import ExpenseTypeForm from "./ExpenseTypeForm";
import fetchAPI from "../../../common/fetchAPI";
import {getAccountTaxCodeByAccountTaxZoneIdAsync, getAccountTaxCodesAsync} from '../taxcode/taxcodeSlice';
import { useLocation } from 'react-router-dom';
import { ShowSwalWithConfirmationMessage } from "../../../common/SweetAlert";
import { findAllByLabelText } from "@testing-library/react";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import { KTIcon } from '../../../_metronic/helpers';
import { DatabaseCheck } from "react-bootstrap-icons";
import { ShowToast } from "../../../common/Toastr";
import { useTranslation } from "react-i18next";
import CustomPagination from "../../../common/Pagination";
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
import { getPageSizeArray } from '../../../common/timeLiveFunction';
import { getFilteredList,sortData, getValueFromResource } from '../../../common/timeLiveFunction';
import Loader from '../../../common/Loader';
import { Value } from "sass";
import PageSizeSelect from '../../../common/PageSizeSelect';
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


const ExpenseType = () => {

    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const location = useLocation();
    const { t } = useTranslation();
    const { expensetypeList, isReload,isLoading, selectedRecord ,sortOrder, sortColumn, search, pageNo, pageSize} = useAppSelector((state) => state.expensetype);
    const {pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const [taxZoneArray, setTaxZoneArray] = useState<any | ''>([]);
    const [taxCodeArray, setTaxCodeArray] = useState<any | ''>([]);
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const params = new URLSearchParams(location.search);
    const AccountHolidayTypeId = params.get('AccountHolidayTypeId');
    const [year, setYear] = useState<string>('1900');
    // const [pageSize, setPageSize] = useState(10);
    // const [currentPage, setCurrentPage] = useState(1);
    // const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const navigate = useNavigate();



    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const getTaxZone_old = async () => {
        const response = await fetchAPI('api/taxzones', 'Get', '', true, '7b6f1610-fd9a-41d2-aa9f-f95225f6a59c');
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountTaxZoneId;
            item.label = item.AccountTaxZone;
            delete item.TaxZone;
            delete item.AccountTaxZoneId;
            delete item.IsDisabled;
            delete item.AccountTaxZone;
        });
        setTaxZoneArray(json);
        if (selectedOption === undefined) {
            setSelectedOption({value: json[0].value, label: json[0].label});
        }        
        if (selectedOption !== undefined) {           
            dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(selectedOption));
        } else {
            dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(json[0].value));
        }
    }
    const getTaxZone = async () => {
        const response = await fetchAPI('api/taxzones', 'Get', '', true, '7b6f1610-fd9a-41d2-aa9f-f95225f6a59c');
        const json = await response.json();
        json.map((item: any) => {
            item.value = item.AccountTaxZoneId;
            item.label = item.AccountTaxZone;
            delete item.TaxZone;
            delete item.AccountTaxZoneId;
            delete item.IsDisabled;
            delete item.AccountTaxZone;
        });
        setTaxZoneArray(json);
        if (selectedOption === undefined) {
            setSelectedOption({value: json[0].value, label: json[0].label});
        }        
        if (selectedOption !== undefined) {           
            dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(selectedOption));
        } else {
            dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(json[0].value));
        }
    }

    useEffect(() => {
        getTaxZone();
    }, []);

    useEffect(()=>{
        if(isReload){
            dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(selectedOption?.value));
        }
    },[isReload])

    useEffect(()=>{
        if(selectedOption){
            dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(selectedOption?.value));
        }
    },[selectedOption])



    // const handlePageChange = (pageNumber: any) => {
    //     setCurrentPage(pageNumber);
    // };
    // const handleSearch = (event: any) => {
    //     const { value } = event.target;
    //     setSearchTerm(value);
    //     setCurrentPage(1);
    // };

    // const handlePageSizeChange = (selectedOption: any) => {
    //     const { value, label } = selectedOption;
    //     setPageSize(Number(value));
    //     setCurrentPage(1);
    // };
    const handlePageChange = (pageNumber: any) => {
        // setCurrentPage(pageNumber);
        let objects = {
            "pageSize": pageSize,
            "pageNo": pageNumber,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    const handleSearch = (event: any) => {
        const { value } = event.target;
        // setSearchTerm(value);
        // setCurrentPage(1);
        let objects = {
            "pageSize": pageSize,
            "pageNo": 1,
            "search": value
        }
        dispatch(updatePagination(objects));
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        // setPageSize(Number(value));
        // setCurrentPage(1);
        let objects = {
            "pageSize": value,
            "pageNo": 1,
            "search": search
        }
        dispatch(updatePagination(objects));
    };

    // const filteredData: any = getFilteredList(expensetypeList, searchTerm);

    // const indexOfLastItem = currentPage * pageSize;
    // const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    // const totalItems = expensetypeList.length;
    // const recordsFiltered = filteredData.length;


    const filteredData: any = getFilteredList(expensetypeList, search);
    const indexOfLastItem = pageNo * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const currentItems = sortData(filteredData, sortOrder, sortColumn).slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = expensetypeList.length;
    const recordsFiltered = filteredData.length;


    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setIsModalOpen(true);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

     const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedRecordExpenseTypeAsync(expensetypeList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            originalPromiseResult.StatusCode === "200" ?
                                ShowToast("Expense type deleted Successfully", 'Success', "success", "toast-top-right") :
                                ShowToast('error', originalPromiseResult[0].ResponseMessage, "error", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
     }

     const handleChange = (data: any) => {
        dispatch(getAccountExpenseTypeByAccountTaxZoneIdAsync(data.value));
        setSelectedOption({ value: data.value, label: data.label });
    }

    return (
        <>
               {isLoading && <Loader />}

            <div className="card card-custom admin-card">
                <div className="card-header card-drop sticky-top bg-white fixed-top">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1"  >
                        {/* {t('Expense Type List')} */}
                        {getValueFromResource('Expense Type List', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-description"
                            data-tooltip-content={getValueFromResource('Configure high-level expense buckets used to group related expense categories. Expense Types also define tax behavior such as GST, VAT, or other applicable tax rules.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={search}
                                onChange={handleSearch}
                                placeholder=
                                // {t('Search')}
                                {getValueFromResource('Search',dispatch, t)}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                        {/* <Select
                                    styles={colourStyles}
                                    options={getPageSizeArray()}
                                    value={getPageSizeArray().find((option: any) => option.value == pageSize.toString())}
                                    onChange={handlePageSizeChange}
                                    className='fs-7 fw-normal'
                                /> */}
                                 <PageSizeSelect onChange={handlePageSizeChange} />


                        </div>
                        {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={pageNo}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(pageNo - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div> */}
                        {(currentItems.length > 0) && (
                            <>
                                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                                <div>
                                    <CustomPagination
                                        currentPage={pageNo}
                                        onPageChange={handlePageChange}
                                        pageSize={pageSize}
                                        totalItems={totalItems}
                                        start={(pageNo - 1) * pageSize}
                                        t={t}
                                    />
                                </div>
                            </>
                        )}


                        <div className='bullet bg-secondary h-35px w-1px mx-3' style={{ marginRight: '2px', display: expensetypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}></div>
                        <div  style={{ marginRight: '2px', display: expensetypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}>
                        <label className="fs-7 fs-7 fw-normal">
                            {/* {t('Tax Zone')} */}
                            {getValueFromResource('Tax Zone',dispatch, t)}
                            </label>
                        </div>
                      
                        <div  style={{ marginRight: '2px',marginLeft: '5px', width: '150px', display: expensetypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                        //style={{ width: '150px' }}
                        >
                            <Select
                                value={selectedOption}
                                className='fs-7 fw-normal'
                                classNamePrefix="select"
                                isSearchable={true}
                                name="taxzoneList"
                                onChange={handleChange}
                                options={taxZoneArray}
                            />
                        </div>
                      
                        {(IsAdd || (IsDelete && expensetypeList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }
                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: expensetypeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {/* {t('Add Expense Type')} */}
                                {getValueFromResource('Add Expense Type',dispatch, t)}
                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: expensetypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{expensetypeList.filter((item: any) => item.isSelected === 1).length}</span> 
                                    {/* {t('Selected')} */}
                                    {getValueFromResource('Selected',dispatch, t)}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: expensetypeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {/* {t('Delete')} */}
                                    {getValueFromResource('Delete',dispatch, t)}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    // <div className="card-body">
                    <div className="card-Report-body">
                        <div className="table-responsive">
                            <ExpenseTypeItem expensetypeList={currentItems} modelRef={modelRef} AccountTaxZoneId={selectedOption?.value} t={t} onopenModal={openModal}
                             oncloseModal={closeModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }

            </div>
            {isModalOpen &&
                <ExpenseTypeForm modelRef={modelRef} AccountTaxZoneId={selectedOption?.value} t={t} oncloseModal={closeModal} />
            }
            <ReactTooltip
                id="tooltip-description"
                style={TOOLTIP_STYLE}
                place="bottom"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />
        </>
    )
}


export default ExpenseType;